import { writable } from 'svelte/store'

/**
 * Custom fetching store creator
 */
export const createFetching = () => {
    const initialState = {}
    const { subscribe, update, set } = writable({ ...initialState })

    return {
        subscribe,
        reset: () => set({ ...initialState }),
        startFetching: key =>
            update(state => {
                state[key] = {
                    ...state[key],
                    fetching: true,
                }
                return state
            }),
        cancelFetching: key =>
            update(state => {
                state[key] = {
                    ...state[key],
                    fetching: false,
                }
                return state
            }),
        setFetched: key =>
            update(state => {
                state[key] = {
                    ...state[key],
                    fetched: true,
                }
                return state
            }),
    }
}
